// The order-total shortcut is replaceable; manually entered split tenders are not.
export function providerSelectionAmounts(amounts, orderTotalMethods) {
    const nonzero = Object.keys(amounts).filter((method) => Number(amounts[method]) !== 0);
    if (nonzero.length === 1 && orderTotalMethods[nonzero[0]]) {
        return { ...amounts, [nonzero[0]]: 0 };
    }
    return { ...amounts };
}

export function hasProviderBalance(remaining) {
    return Number.isFinite(remaining) && Math.round(remaining * 100) > 0;
}
